module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-b-10"
  }, [_c('div', {
    staticClass: "form-item tx-c m-b-10"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('el-table', {
    staticClass: "m-b-10",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.childValue
    }
  }, [_vm._l((_vm.inputList), function(item) {
    return _c('el-table-column', {
      attrs: {
        "label": item.default.title
      },
      scopedSlots: {
        default: function(scope) {
          return [_c('div', {
            staticClass: "p-t-10 p-b-20"
          }, [_c('el-form-item', {
            staticStyle: {
              "margin-bottom": "0"
            },
            attrs: {
              "label-width": "0",
              "prop": _vm.getFieldName(scope.$index, item.default.name),
              "rules": _vm.childRules[item.default.name]
            }
          }, [(item.default.type == _vm.TYPE_INPUTTEXT) ? _c('honray-input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.childValue[scope.$index][item.default.name]),
              expression: "childValue[scope.$index][item.default.name]"
            }],
            attrs: {
              "name": item.default.name,
              "type": item.input.write_type,
              "minLength": item.input.write_min,
              "maxLength": item.input.write_max,
              "disabled": _vm.disabled,
              "rules": _vm.childRules,
              "isNeed": item.default.is_needed === 1
            },
            domProps: {
              "value": (_vm.childValue[scope.$index][item.default.name])
            },
            on: {
              "input": [function($event) {
                var $$exp = _vm.childValue[scope.$index],
                  $$idx = item.default.name;
                if (!Array.isArray($$exp)) {
                  _vm.childValue[scope.$index][item.default.name] = $event
                } else {
                  $$exp.splice($$idx, 1, $event)
                }
              }, _vm.change]
            }
          }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_PASSWORD) ? _c('honray-password', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.childValue[scope.$index][item.default.name]),
              expression: "childValue[scope.$index][item.default.name]"
            }],
            attrs: {
              "name": item.default.name,
              "encryptType": item.password.encrypt_type,
              "encryptSplit": item.password.encrypt_split,
              "minLength": item.password.write_min,
              "maxLength": item.password.write_max,
              "disabled": _vm.disabled,
              "isNeed": item.default.is_needed === 1,
              "rules": _vm.childRules
            },
            domProps: {
              "value": (_vm.childValue[scope.$index][item.default.name])
            },
            on: {
              "input": [function($event) {
                var $$exp = _vm.childValue[scope.$index],
                  $$idx = item.default.name;
                if (!Array.isArray($$exp)) {
                  _vm.childValue[scope.$index][item.default.name] = $event
                } else {
                  $$exp.splice($$idx, 1, $event)
                }
              }, _vm.change]
            }
          }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_TEXTAREA) ? _c('honray-textarea', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.childValue[scope.$index][item.default.name]),
              expression: "childValue[scope.$index][item.default.name]"
            }],
            attrs: {
              "name": item.default.name,
              "minLength": item.textarea.write_min,
              "maxLength": item.textarea.write_max,
              "disabled": _vm.disabled,
              "isNeed": item.default.is_needed === 1,
              "rules": _vm.childRules
            },
            domProps: {
              "value": (_vm.childValue[scope.$index][item.default.name])
            },
            on: {
              "input": [function($event) {
                var $$exp = _vm.childValue[scope.$index],
                  $$idx = item.default.name;
                if (!Array.isArray($$exp)) {
                  _vm.childValue[scope.$index][item.default.name] = $event
                } else {
                  $$exp.splice($$idx, 1, $event)
                }
              }, _vm.change]
            }
          }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_RADIO) ? _c('honray-radio', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.childValue[scope.$index][item.default.name]),
              expression: "childValue[scope.$index][item.default.name]"
            }],
            attrs: {
              "name": item.default.name,
              "options": item.radio_option,
              "disabled": _vm.disabled,
              "rules": _vm.childRules
            },
            domProps: {
              "value": (_vm.childValue[scope.$index][item.default.name])
            },
            on: {
              "input": [function($event) {
                var $$exp = _vm.childValue[scope.$index],
                  $$idx = item.default.name;
                if (!Array.isArray($$exp)) {
                  _vm.childValue[scope.$index][item.default.name] = $event
                } else {
                  $$exp.splice($$idx, 1, $event)
                }
              }, _vm.change]
            }
          }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_CHECKBOX) ? _c('honray-checkbox', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.childValue[scope.$index][item.default.name]),
              expression: "childValue[scope.$index][item.default.name]"
            }],
            attrs: {
              "name": item.default.name,
              "selectMin": item.checkbox.select_min,
              "selectMax": item.checkbox.select_max,
              "options": item.checkbox_option,
              "disabled": _vm.disabled,
              "isNeed": item.default.is_needed === 1,
              "rules": _vm.childRules
            },
            domProps: {
              "value": (_vm.childValue[scope.$index][item.default.name])
            },
            on: {
              "input": [function($event) {
                var $$exp = _vm.childValue[scope.$index],
                  $$idx = item.default.name;
                if (!Array.isArray($$exp)) {
                  _vm.childValue[scope.$index][item.default.name] = $event
                } else {
                  $$exp.splice($$idx, 1, $event)
                }
              }, _vm.change]
            }
          }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_SELECT) ? _c('honray-select', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.childValue[scope.$index][item.default.name]),
              expression: "childValue[scope.$index][item.default.name]"
            }],
            attrs: {
              "name": item.default.name,
              "options": item.select_option,
              "disabled": _vm.disabled,
              "rules": _vm.childRules
            },
            domProps: {
              "value": (_vm.childValue[scope.$index][item.default.name])
            },
            on: {
              "input": [function($event) {
                var $$exp = _vm.childValue[scope.$index],
                  $$idx = item.default.name;
                if (!Array.isArray($$exp)) {
                  _vm.childValue[scope.$index][item.default.name] = $event
                } else {
                  $$exp.splice($$idx, 1, $event)
                }
              }, _vm.change]
            }
          }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_STRUCT) ? _c('honray-struct', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.childValue[scope.$index][item.default.name]),
              expression: "childValue[scope.$index][item.default.name]"
            }],
            attrs: {
              "selectType": item.struct.select_type,
              "name": item.default.name,
              "options": item.struct_option,
              "disabled": _vm.disabled,
              "rules": _vm.childRules
            },
            domProps: {
              "value": (_vm.childValue[scope.$index][item.default.name])
            },
            on: {
              "input": [function($event) {
                var $$exp = _vm.childValue[scope.$index],
                  $$idx = item.default.name;
                if (!Array.isArray($$exp)) {
                  _vm.childValue[scope.$index][item.default.name] = $event
                } else {
                  $$exp.splice($$idx, 1, $event)
                }
              }, _vm.change]
            }
          }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_PERSON) ? _c('honray-people', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.childValue[scope.$index][item.default.name]),
              expression: "childValue[scope.$index][item.default.name]"
            }],
            attrs: {
              "selectType": item.people.select_type,
              "options": item.people_option,
              "disabled": _vm.disabled,
              "rules": _vm.childRules
            },
            domProps: {
              "value": (_vm.childValue[scope.$index][item.default.name])
            },
            on: {
              "input": [function($event) {
                var $$exp = _vm.childValue[scope.$index],
                  $$idx = item.default.name;
                if (!Array.isArray($$exp)) {
                  _vm.childValue[scope.$index][item.default.name] = $event
                } else {
                  $$exp.splice($$idx, 1, $event)
                }
              }, _vm.change]
            }
          }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_DATE) ? _c('honray-date', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.childValue[scope.$index][item.default.name]),
              expression: "childValue[scope.$index][item.default.name]"
            }],
            attrs: {
              "name": item.default.name,
              "type": item.date.type,
              "config": item.date,
              "isRange": item.date.range_status == 1,
              "placeholder": "选择时间",
              "disabled": _vm.disabled,
              "rules": _vm.childRules
            },
            domProps: {
              "value": (_vm.childValue[scope.$index][item.default.name])
            },
            on: {
              "input": [function($event) {
                var $$exp = _vm.childValue[scope.$index],
                  $$idx = item.default.name;
                if (!Array.isArray($$exp)) {
                  _vm.childValue[scope.$index][item.default.name] = $event
                } else {
                  $$exp.splice($$idx, 1, $event)
                }
              }, _vm.change]
            }
          }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_TIME) ? _c('honray-time', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.childValue[scope.$index][item.default.name]),
              expression: "childValue[scope.$index][item.default.name]"
            }],
            attrs: {
              "name": item.default.name,
              "type": item.time.select_type,
              "config": item.time,
              "isRange": item.time.range_status == 1,
              "placeholder": "选择日期",
              "disabled": _vm.disabled,
              "rules": _vm.childRules
            },
            domProps: {
              "value": (_vm.childValue[scope.$index][item.default.name])
            },
            on: {
              "input": [function($event) {
                var $$exp = _vm.childValue[scope.$index],
                  $$idx = item.default.name;
                if (!Array.isArray($$exp)) {
                  _vm.childValue[scope.$index][item.default.name] = $event
                } else {
                  $$exp.splice($$idx, 1, $event)
                }
              }, _vm.change]
            }
          }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_BOTH_DATE_TIME) ? _c('honray-datetime', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.childValue[scope.$index][item.default.name]),
              expression: "childValue[scope.$index][item.default.name]"
            }],
            attrs: {
              "name": item.default.name,
              "config": item.datetime,
              "isRange": item.datetime.range_status == 1,
              "placeholder": "选择日期时间",
              "disabled": _vm.disabled,
              "rules": _vm.childRules
            },
            domProps: {
              "value": (_vm.childValue[scope.$index][item.default.name])
            },
            on: {
              "input": [function($event) {
                var $$exp = _vm.childValue[scope.$index],
                  $$idx = item.default.name;
                if (!Array.isArray($$exp)) {
                  _vm.childValue[scope.$index][item.default.name] = $event
                } else {
                  $$exp.splice($$idx, 1, $event)
                }
              }, _vm.change]
            }
          }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_FILE) ? _c('honray-upload', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.childValue[scope.$index][item.default.name]),
              expression: "childValue[scope.$index][item.default.name]"
            }],
            attrs: {
              "title": item.default.title,
              "name": item.default.name,
              "config": item.file,
              "uploadUrl": _vm.host + 'form/upload/' + item.default.field_id,
              "disabled": _vm.disabled,
              "rules": _vm.childRules
            },
            domProps: {
              "value": (_vm.childValue[scope.$index][item.default.name])
            },
            on: {
              "input": [function($event) {
                var $$exp = _vm.childValue[scope.$index],
                  $$idx = item.default.name;
                if (!Array.isArray($$exp)) {
                  _vm.childValue[scope.$index][item.default.name] = $event
                } else {
                  $$exp.splice($$idx, 1, $event)
                }
              }, _vm.change]
            }
          }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_EDITOR && item.default.field_auth != 10) ? _c('honray-editor', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.childValue[scope.$index][item.default.name]),
              expression: "childValue[scope.$index][item.default.name]"
            }],
            ref: item.default.name,
            refInFor: true,
            attrs: {
              "id": item.default.name,
              "col": item.default.layout,
              "width": 650,
              "height": 200,
              "uploadImgUrl": _vm.host + 'admin/upload',
              "codeDefaultLang": item.editor.pc_code_type,
              "mapKey": item.editor.pc_map_key,
              "fileMaxSize": item.editor.pc_file_max,
              "fileUnit": _vm.getUnitText(item.editor.pc_file_unit),
              "usePlupload": true,
              "rules": _vm.childRules
            },
            domProps: {
              "value": (_vm.childValue[scope.$index][item.default.name])
            },
            on: {
              "input": [function($event) {
                var $$exp = _vm.childValue[scope.$index],
                  $$idx = item.default.name;
                if (!Array.isArray($$exp)) {
                  _vm.childValue[scope.$index][item.default.name] = $event
                } else {
                  $$exp.splice($$idx, 1, $event)
                }
              }, _vm.change]
            }
          }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_EDITOR && (_vm.hasEditAuth(item))) ? _c('div', {
            attrs: {
              "rules": _vm.childRules
            },
            domProps: {
              "innerHTML": _vm._s(_vm.childValue[scope.$index][item.default.name])
            },
            on: {
              "input": _vm.change
            }
          }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_CASCADER) ? _c('honray-cascader', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.childValue[scope.$index][item.default.name]),
              expression: "childValue[scope.$index][item.default.name]"
            }],
            attrs: {
              "id": item.default.field_id,
              "disabled": _vm.disabled,
              "type": item.link.type,
              "filterable": item.link.has_search == 1,
              "areaLimit": item.link.area_limit == 1,
              "areaConfig": item.link.area_config,
              "showAllLevels": item.link.result_show == _vm.CASCADER_SHOW_FULL,
              "rules": _vm.childRules
            },
            domProps: {
              "value": (_vm.childValue[scope.$index][item.default.name])
            },
            on: {
              "input": [function($event) {
                var $$exp = _vm.childValue[scope.$index],
                  $$idx = item.default.name;
                if (!Array.isArray($$exp)) {
                  _vm.childValue[scope.$index][item.default.name] = $event
                } else {
                  $$exp.splice($$idx, 1, $event)
                }
              }, _vm.change]
            }
          }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_FOREIGNKEY) ? _c('honray-foreignkey', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.childValue[scope.$index][item.default.name]),
              expression: "childValue[scope.$index][item.default.name]"
            }],
            attrs: {
              "disabled": _vm.disabled,
              "id": item.default.field_id,
              "name": item.default.name,
              "filterable": item.key.has_search == 1,
              "isLink": item.key.is_link == 1,
              "linkField": item.key.link_pid,
              "efficientOptions": item.allOptions,
              "majorField": item.default.key_major,
              "depentField": item.default.key_depent,
              "type": item.key.type,
              "keyItem": item,
              "keyFilter": item.default.key_filter,
              "keyCascade": item.default.key_cascade,
              "keyFillin": item.default.key_fillin,
              "extraFieldList": _vm.extraFieldList,
              "hasNull": item.key.has_null == 1
            },
            domProps: {
              "value": (_vm.childValue[scope.$index][item.default.name])
            },
            on: {
              "input": [function($event) {
                var $$exp = _vm.childValue[scope.$index],
                  $$idx = item.default.name;
                if (!Array.isArray($$exp)) {
                  _vm.childValue[scope.$index][item.default.name] = $event
                } else {
                  $$exp.splice($$idx, 1, $event)
                }
              }, _vm.change]
            }
          }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_USER) ? _c('honray-user', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.childValue[scope.$index][item.default.name]),
              expression: "childValue[scope.$index][item.default.name]"
            }],
            attrs: {
              "rules": _vm.childRules,
              "user": item.user_info
            },
            domProps: {
              "value": (_vm.childValue[scope.$index][item.default.name])
            },
            on: {
              "input": function($event) {
                var $$exp = _vm.childValue[scope.$index],
                  $$idx = item.default.name;
                if (!Array.isArray($$exp)) {
                  _vm.childValue[scope.$index][item.default.name] = $event
                } else {
                  $$exp.splice($$idx, 1, $event)
                }
              }
            }
          }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_DEALTIME) ? _c('honray-dealtime', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.childValue[scope.$index][item.default.name]),
              expression: "childValue[scope.$index][item.default.name]"
            }],
            attrs: {
              "unit": item.deal_time.unit,
              "rules": _vm.childRules
            },
            domProps: {
              "value": (_vm.childValue[scope.$index][item.default.name])
            },
            on: {
              "input": function($event) {
                var $$exp = _vm.childValue[scope.$index],
                  $$idx = item.default.name;
                if (!Array.isArray($$exp)) {
                  _vm.childValue[scope.$index][item.default.name] = $event
                } else {
                  $$exp.splice($$idx, 1, $event)
                }
              }
            }
          }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_MULTIRELATE) ? _c('honray-relate', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.childValue[scope.$index][item.default.name]),
              expression: "childValue[scope.$index][item.default.name]"
            }],
            attrs: {
              "id": item.default.field_id,
              "name": item.default.name,
              "config": item.multi_link,
              "rules": _vm.childRules,
              "api": 'multi_link',
              "is-need": item.default.is_needed
            },
            domProps: {
              "value": (_vm.childValue[scope.$index][item.default.name])
            },
            on: {
              "input": function($event) {
                var $$exp = _vm.childValue[scope.$index],
                  $$idx = item.default.name;
                if (!Array.isArray($$exp)) {
                  _vm.childValue[scope.$index][item.default.name] = $event
                } else {
                  $$exp.splice($$idx, 1, $event)
                }
              }
            }
          }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_PHOTO) ? _c('honray-upload-img', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.childValue[scope.$index][item.default.name]),
              expression: "childValue[scope.$index][item.default.name]"
            }],
            attrs: {
              "id": item.default.field_id,
              "config": item.image,
              "uploadUrl": _vm.host + 'form/upload/' + item.default.field_id
            },
            domProps: {
              "value": (_vm.childValue[scope.$index][item.default.name])
            },
            on: {
              "input": function($event) {
                var $$exp = _vm.childValue[scope.$index],
                  $$idx = item.default.name;
                if (!Array.isArray($$exp)) {
                  _vm.childValue[scope.$index][item.default.name] = $event
                } else {
                  $$exp.splice($$idx, 1, $event)
                }
              }
            }
          }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_SUBRELATE) ? _c('honray-relate', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.childValue[scope.$index][item.default.name]),
              expression: "childValue[scope.$index][item.default.name]"
            }],
            attrs: {
              "id": item.default.field_id,
              "name": item.default.name,
              "config": item.child,
              "rules": _vm.childRules,
              "api": 'child',
              "is-need": item.default.is_needed
            },
            domProps: {
              "value": (_vm.childValue[scope.$index][item.default.name])
            },
            on: {
              "input": function($event) {
                var $$exp = _vm.childValue[scope.$index],
                  $$idx = item.default.name;
                if (!Array.isArray($$exp)) {
                  _vm.childValue[scope.$index][item.default.name] = $event
                } else {
                  $$exp.splice($$idx, 1, $event)
                }
              }
            }
          }) : _vm._e()])])]
        }
      }
    })
  }), _vm._v(" "), (!_vm.disabled) ? _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "100px"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.deleteRow(scope.$index)
            }
          }
        }, [_vm._v("删除")])]
      }
    }
  }) : _vm._e()], true), _vm._v(" "), (!_vm.disabled) ? _c('div', {
    staticClass: "tx-c m-t-10"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addRow
    }
  }, [_vm._v("添加一行")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6cedb529!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/business/inputs/honraySubform.vue
// module id = 1906
// module chunks = 2